import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navabar';
import Footer from '../components/Footer';

const newsData = [
  {
    id: '1',
    image: '/section/section1.png',
    title: 'Inauguration du centre de formation',
    description: `Notre nouveau centre de formation vient d'ouvrir ses portes à Cotonou. 
    Cette infrastructure moderne permettra de former chaque année plus de 200 jeunes aux métiers 
    d'avenir. Le centre dispose d'équipements de pointe et de formateurs qualifiés.`,
    fullDescription: `
    L’ONG Action-Humanitaire Benin vise à promouvoir un développement inclusif et durable pour améliorer les conditions de vie des populations béninoises. Nous nous engageons à maximiser notre impact sur le développement à travers cinq grands domaines, appelés les "High 5", identifiés pour leur potentiel d'expansion :

1. Intégration et amélioration de la qualité de vie des populations vulnérables :
•  Nous œuvrons à intégrer et améliorer les conditions de vie des communautés locales.
•  Nous mettons en place des programmes de réinsertion des jeunes dans le marché du travail pour lutter contre le chômage et la marginalisation.

2. Sensibilisation et éducation sur les questions environnementales et sanitaires :
•  Nous éduquons et sensibilisons les communautés aux enjeux environnementaux et sanitaires.
•  Nous informons sur les dangers des voyages clandestins vers l'Europe et les risques encourus par nos sœurs qui partent travailler au moyen orient comme la Koweït, la Jordanie etc....

3. Accès à l'eau potable :
•  Nous facilitons l'accès à une eau potable et saine pour tous en construisant des forages d'eau.
•  Nous sensibilisons les populations à l'importance de l'hygiène de l'eau pour prévenir les maladies.

4. Santé et sécurité alimentaire :
•  Nous travaillons à garantir l'accès aux soins de santé de base pour la population et à fournir des informations pour une bonne hygiène de vie.
•  Nous luttons contre la famine en mettant en place des programmes de sécurité alimentaire et de nutrition.

5. Moderniser le cadre de vie des populations défavorisées :
•  Nous combattons activement les inégalités sociales pour une société plus juste et équitable, en passant par une bonne éducation.
•  Nous développons des initiatives pour améliorer les infrastructures et les services de base dans les communautés défavorisées.

    `
  },
  {
    id: '2',
    image: '/section/section2.png',
    title: 'Campagne de sensibilisation sanitaire',
    description: 'Lancement de notre nouvelle campagne de sensibilisation sanitaire',
    fullDescription: `
          Les Objectifs de Développement Durable (ODD), adoptés par l'ONU en 2015 dans le cadre de l'Agenda 2030, sont un ensemble de 17 objectifs globaux visant à assurer un développement équilibré, inclusif et durable pour tous. Voici les ODD en détail :  

🌍 Les 17 Objectifs de Développement Durable

1️⃣ Pas de pauvreté
Éliminer l'extrême pauvreté sous toutes ses formes.  

2️⃣ Faim "Zéro"
Garantir la sécurité alimentaire et promouvoir une agriculture durable.  

3️⃣ Bonne santé et bien-être
Assurer un accès universel aux soins de santé.  

4️⃣ Éducation de qualité
Offrir une éducation inclusive et équitable pour tous.  

5️⃣ Égalité entre les sexes
Éliminer les discriminations et autonomiser les femmes et les filles.  

6️⃣ Eau propre et assainissement
Assurer l'accès à l'eau potable et aux services d'assainissement.  

7️⃣ Énergie propre et d'un coût abordable
Promouvoir l'accès à des sources d'énergie durable.  

8️⃣ Travail décent et croissance économique
Encourager des conditions de travail équitables et une croissance inclusive.  

9️⃣ Industrie, innovation et infrastructure
Construire des infrastructures résilientes et durables.  

🔟 Réduction des inégalités
Favoriser l'inclusion sociale et économique de tous.  

1️⃣1️⃣ Villes et communautés durables
Développer des zones urbaines sûres et écologiques.  

1️⃣2️⃣ Consommation et production responsables
Réduire le gaspillage et promouvoir une économie circulaire.  

1️⃣3️⃣ Lutte contre les changements climatiques
Prendre des mesures urgentes pour combattre le dérèglement climatique.  

1️⃣4️⃣ Vie aquatique
Protéger les océans et les ressources marines.  

1️⃣5️⃣ Vie terrestre
Préserver les écosystèmes terrestres et la biodiversité.  

1️⃣6️⃣ Paix, justice et institutions efficaces
Promouvoir des sociétés pacifiques et inclusives. 

1️⃣7️⃣ Partenariats pour la réalisation des objectifs
Renforcer la coopération internationale et l'accès aux financements pour le développement.


💡 Pourquoi ces ODD sont-ils cruciaux ?
Ils permettent aux gouvernements, ONG et entreprises de travailler ensemble pour éradiquer les inégalités, protéger l'environnement et garantir un avenir durable.

    `
  }
];

const NewDetailsPage = () => {
  const { id } = useParams();
  const news = newsData.find(item => item.id === id);

  if (!news) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-2xl text-gray-800">Article non trouvé</h1>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="bg-white shadow-lg rounded-2xl overflow-hidden">
          {/* Image en haut */}
          <div className="w-full h-[400px] relative">
            <img
              src={news.image}
              alt={news.title}
              className="w-full h-full object-contain bg-gray-50"
            />
          </div>

          {/* Contenu */}
          <div className="p-8">
            <div className="prose max-w-none">
              {news.fullDescription.split('\n\n').map((paragraph, index) => {
                // Titre principal avec emojis
                if (paragraph.includes("🌍")) {
                  return (
                    <h2 key={index} className="text-xl font-bold text-gray-900 mb-6">
                      {paragraph}
                    </h2>
                  );
                }

                // Gestion des numéros avec emojis (1️⃣, 2️⃣, etc.)
                if (paragraph.match(/[1-9️⃣]\s*–/)) {
                  return (
                    <div key={index} className="flex items-start gap-4 mb-4">
                      <span className="text-gray-900">{paragraph}</span>
                    </div>
                  );
                }

                // Gestion des explications avec emojis (💡)
                if (paragraph.startsWith('💡')) {
                  return (
                    <div key={index} className="my-6 bg-gray-50 p-4 rounded-lg">
                      <p className="text-gray-800">
                        {paragraph}
                      </p>
                    </div>
                  );
                }

                // Format standard numéroté (1., 2., etc.)
                if (paragraph.match(/^\d\./)) {
                  const [number, ...content] = paragraph.split(':');
                  return (
                    <div key={index} className="mb-4">
                      <h3 className="text-base font-semibold text-gray-900">
                        {number}:
                      </h3>
                      <div className="mt-2 ml-4">
                        {content.join(':').trim()}
                      </div>
                    </div>
                  );
                }
                
                // Gestion des titres numérotés
                if (paragraph.match(/^\d\./)) {
                  const [number, ...content] = paragraph.split(':');
                  return (
                    <div key={index} className="mb-4">
                      <h3 className="text-base font-semibold text-gray-900">
                        {number}:
                      </h3>
                      <div className="mt-2 ml-4">
                        {content.join(':').trim()}
                      </div>
                    </div>
                  );
                }
                
                // Gestion des points avec puces
                if (paragraph.trim().startsWith('•')) {
                  return (
                    <ul key={index} className="mb-4 ml-6">
                      {paragraph.split('\n').map((line, lineIndex) => (
                        line.trim() && (
                          <li key={lineIndex} className="flex items-start mb-2">
                            <span className="text-gray-700 mr-2">•</span>
                            <span className="text-gray-700 text-base">
                              {line.replace('•', '').trim()}
                            </span>
                          </li>
                        )
                      ))}
                    </ul>
                  );
                }

                // Paragraphes normaux
                return (
                  <p key={index} className="text-base text-gray-700 mb-4">
                    {paragraph}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NewDetailsPage;
